module.exports = __webpack_public_path__ + "img/distribution-icon.4752957d.svg";